module.exports = __webpack_public_path__ + "media/application/images/2023/03_still-1920x1080-000495d947beb95cc22f5512d840db34.png";